/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Hero_ReelInputs */

const en_road_dude_hero_reel = /** @type {(inputs: Road_Dude_Hero_ReelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FEATURED REMIX`)
};

const zh_road_dude_hero_reel = /** @type {(inputs: Road_Dude_Hero_ReelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选翻拍`)
};

/**
* | output |
* | --- |
* | "FEATURED REMIX" |
*
* @param {Road_Dude_Hero_ReelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_hero_reel = /** @type {((inputs?: Road_Dude_Hero_ReelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Hero_ReelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_hero_reel(inputs)
	return zh_road_dude_hero_reel(inputs)
});
export { road_dude_hero_reel as "road_dude.hero.reel" }